export default {
  computed: {
    adminRole() {
      return this.$store.state.header?.headerData?.isAdminRole ?? false
    }
  }
}
